import React, { useEffect, useState} from "react";
import CCTM_parse from "../../CCTM_parse";
import CCTM_transform from "../../CCTM_transform";

export default function CCTM_nav(props) {
    
    let Component = props.component;
    if (typeof props.postRender == "function"){
        Component = props.postRender(props.component,props)
    } 
   return  <Component {...props}>
                {props.children}
            </Component>
}